<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j3fjFI/tc-custom/9781936535408.jpg?1719976424711" alt="This image is the cover for the book Holding the Line, Special Ops Squad"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holding the Line, Special Ops Squad
      </h1>
      <p class="bookDescription body article font2">
        <p>As members of the Alliance of Light, humans have committed to the battle against the Ilion Federation, and they’re doing their part. But the Alliance’s army is fragmented, and to unify their forces, the army’s leaders must do the unthinkable: they form the First Combined Regiment, made up of soldiers from every alien race in the Alliance.<br/><br/>The Spec Ops Squad is supposed to be the best of the best, an elite group within the First Combined Regiment to take care of the dirtiest jobs. Sergeant Bart “Dragon” Drak isn’t too surprised to learn that these warriors don’t have a whole lot in common, and it’s obvious that it will take a lot of work to turn a bunch of commandos into a team. He didn’t sign up for this, but he’s got to see it through.<br/><br/>In the midst of training, the Spec Ops Squad is called off to planet Dintsen to fight off an invasion from the Ilion Federation. With such an elite fighting force, beating them back should be a piece of cake... except Ilion’s got the same kind of team on their side, and theirs are better trained. Drak will have to face down tremendous odds and new challenges to bring his team home.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Shelley
      </h2>
      
      <p class="authorDescription body article">Rick Shelley (January 1, 1947 - January 27, 2001) was a military science fiction author. In addition to a plethora of short fiction, he also wrote the Dirigent Mercenary Corps, Spec Ops Squad, Federation War, 13 Spaceborn, Seven Towers, and Varayan Memoir series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Jabberwocky Literary Agency
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67a4fb7c